// 資料庫設定
export const databaseConfig = {
  // Firebase 配置
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || ''
  },
  
  // API 配置（Cloud SQL 透過後端 API）
  api: {
    url: process.env.REACT_APP_API_URL || 'https://teleworker-api-5ubu67iiga-de.a.run.app',
    timeout: 30000
  }
};

// 檢查必要設定
export const validateConfig = () => {
  const errors: string[] = [];
  
  if (!databaseConfig.firebase.apiKey) errors.push('缺少 Firebase API Key');
  if (!databaseConfig.firebase.authDomain) errors.push('缺少 Firebase Auth Domain');
  if (!databaseConfig.api.url) errors.push('缺少 API URL');
  
  if (errors.length > 0) {
    throw new Error(`設定錯誤: ${errors.join(', ')}`);
  }
  
  return true;
};

// 匯出預設設定
export default databaseConfig; 